(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bn-email-popup"]) return;
  try {
    
function initBuhnPopup(){
const dialog=document.querySelector('[data-bn-popup]');
if(!dialog||dialog.dataset.initialized)return;
dialog.dataset.initialized='true';
const seenKey='bn-email-invitation-seen-v1';
const pendingKey='bn-email-invitation-pending';
const read=(key)=>{try{return localStorage.getItem(key)}catch{return null}};
const remember=()=>{try{localStorage.setItem(seenKey,'1')}catch{try{sessionStorage.setItem(seenKey,'1')}catch{}}};
let sessionSeen=false;let pending=false;
try{sessionSeen=sessionStorage.getItem(seenKey)==='1';pending=sessionStorage.getItem(pendingKey)==='1'}catch{}
const hasResponse=!!dialog.querySelector('[data-bn-popup-success],[data-bn-popup-errors]');
const ownResponse=hasResponse&&(location.hash==='#bn-popup-form'||pending);
const open=()=>{if(!dialog.isConnected||dialog.open||document.querySelector('dialog[open]'))return;dialog.showModal();document.body.classList.add('bn-popup-active');remember();dialog.querySelector('h2').focus()};
const close=()=>dialog.close();
dialog.querySelectorAll('[data-bn-popup-close]').forEach(button=>button.addEventListener('click',close));
dialog.addEventListener('close',()=>{document.body.classList.remove('bn-popup-active');remember()});
dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close()});
dialog.querySelector('form').addEventListener('submit',()=>{remember();try{sessionStorage.setItem(pendingKey,'1')}catch{}});
if(ownResponse||location.hash==='#bn-popup-form'){try{sessionStorage.removeItem(pendingKey)}catch{}open()}
else if(!read(seenKey)&&!sessionSeen&&!hasResponse){setTimeout(()=>{if(document.activeElement?.matches('input,textarea,select')){document.activeElement.addEventListener('blur',open,{once:true})}else{open()}},Number(dialog.dataset.delay)||4000)}
}
initBuhnPopup();document.addEventListener('shopify:section:load',initBuhnPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
